import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import "../Admin/admin.css";
import { endpoints } from "../_config";
import { get, post } from "../_services/apiService";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const Services = () => {
    const [loading, setLoading] = useState(true);
    const [serviceType, setServiceType] = useState([]);
    const [isEditMode, setIsEditMode] = useState(false);
    const [formData, setFormData] = useState({
        serviceId: 0,
        serviceName: "",
        description: "",
        isActive: true,
        createdBy: 2,
        isContact: false,
        isQuote: false
    });

    // ✅ Handle input changes
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    // ✅ Save (POST) Service Type
    const onSave = async (e) => {
        e.preventDefault();
        try {
            const response = await post(endpoints.SaveServiceType, formData);

            if (response.isSuccess === 200) {
                toast.success("Service saved successfully ✅");

                // Reset form
                setFormData({
                    serviceId: 0,
                    serviceName: "",
                    description: "",
                    isActive: true,
                    createdBy: 2
                });

                // Close modal
                window.bootstrap.Modal.getInstance(
                    document.getElementById("modeldata")
                )?.hide();

                // Refresh service list
                getServiceType();
            } else {
                toast.error(response.message || "Failed to save service ❌");
            }
        } catch (error) {
            console.error("Error saving service:", error);
            toast.error("Something went wrong while saving ❌");
        }
    };

    // ✅ Delete service by ID
    const deleteServiceType = async (serviceId) => {
        if (!window.confirm("Are you sure you want to delete this service type?")) return;

        try {
            const response = await get(`${endpoints.DeleteServiceTypeById}?pServiceTypeId=${serviceId}`);

            if (response.isSuccess === 200) {
                toast.success("Service deleted successfully 🗑️");
                getServiceType();
            } else {
                toast.error(response.message || "Failed to delete service ❌");
            }
        } catch (error) {
            console.error("Error deleting service type:", error);
            toast.error("Something went wrong while deleting ❌");
        }
    };

    // ✅ Handle Edit Click
    const handleEdit = (item) => {
        setFormData({
            serviceId: item.serviceId,
            serviceName: item.serviceName,
            description: item.description,
            isActive: item.isActive,
            createdBy: 2,
        });
        setIsEditMode(true);

        // Open modal programmatically
        const modal = new window.bootstrap.Modal(
            document.getElementById("modeldata")
        );
        modal.show();
    };

    // ✅ Fetch service types
    const getServiceType = async () => {
        try {
            setLoading(true);
            const response = await get(endpoints.GetServiceTypeAll);
            if (response.isSuccess === 200) {
                setServiceType(response.data);
            } else {
                setServiceType([]);
            }
        } catch (error) {
            console.error("Error fetching service types:", error);
            setServiceType([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getServiceType();
    }, []);

    // ✅ Fetch service types
    const serviceTypeToggle = async (serviceId, name) => {
        try {
            setLoading(true);
            const response = await get(`${endpoints.ActiveServiceTypeById}?pServiceTypeId=${serviceId}&name=${name}`);
            if (response.isSuccess === 200) {
                getServiceType();
            }
        } catch (error) {
            console.error("Error fetching service types:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <AdminLayout>
                <div className="product_wepper">
                    <div className="container-fluid">
                        <div className="row justify-content-end">
                            <div className="col-lg-7">
                                <div className="row align-items-center justify-content-end">
                                    <div className="col-lg-5 col-md-6 col-sm-6 add_subcategory">
                                        {/* ✅ Open modal */}
                                        <button
                                            type="button"
                                            className="all_sumbit_button"
                                            data-bs-toggle="modal"
                                            data-bs-target="#modeldata"
                                        >
                                            + Add Service Type
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* ✅ Table Section */}
                        <div
                            className="mt-3 product_hedding_table_main"
                            style={{ overflowX: "auto" }}
                        >
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Service Name</th>
                                        {/* <th>Description</th> */}
                                        <th>Active</th>
                                        <th>Contact</th>
                                        <th>Quote</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                Loading...
                                            </td>
                                        </tr>
                                    ) : serviceType.length > 0 ? (
                                        serviceType.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.serviceName}</td>
                                                {/* <td>{item.description}</td> */}
                                                <td style={{ cursor: "pointer" }} onClick={() => serviceTypeToggle(item?.serviceId, "isActive")}>{item.isActive === 1 ? "Active" : "Inactive"}</td>
                                                {/* <td style={{ cursor: "pointer" }} onClick={() => serviceTypeToggle(item?.serviceId, "isContact")}>{item.isContact === 1 ? "Yes" : "No"}</td> */}
                                                {/* <td style={{ cursor: "pointer" }} onClick={() => serviceTypeToggle(item?.serviceId, "isQuote")}>{item.isQuote === 1 ? "Yes" : "No"}</td> */}
                                                <td>
                                                    <div className="form-check form-switch">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            role="switch"
                                                            id={`switch-${item.serviceId}`}
                                                            checked={item.isContact === 1}
                                                            onChange={() => serviceTypeToggle(item?.serviceId, "isContact")}
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="form-check form-switch">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            role="switch"
                                                            id={`switch-${item.serviceId}`}
                                                            checked={item.isQuote === 1}
                                                            onChange={() => serviceTypeToggle(item?.serviceId, "isQuote")}
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="action_btn_weepr">
                                                        <span className="edit_icon_wepper"
                                                            onClick={() =>
                                                                handleEdit(item)
                                                            }
                                                        >
                                                            <svg id="Layer_1" viewBox="0 0 512 512" width="15" height="15" xmlns="http://www.w3.org/2000/svg">
                                                                <g transform="matrix(1,0,0,1,0,0)">
                                                                    <path
                                                                        d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z"
                                                                        fill="#000"
                                                                    ></path>
                                                                    <path
                                                                        d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z"
                                                                        fill="url(#gradient1)"
                                                                    ></path>
                                                                    <defs>
                                                                        <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                                                            <stop offset="0%" stop-color="#000"></stop>
                                                                            <stop offset="100%" stop-color="#000"></stop>
                                                                        </linearGradient>
                                                                    </defs>
                                                                </g>
                                                            </svg>
                                                        </span>
                                                        <span className="delete_icon_weepr" onClick={() => deleteServiceType(item.serviceId)} >
                                                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="15" height="15" viewBox="0 0 24 24">
                                                                <path
                                                                    d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z"
                                                                    fill="#FF0000"
                                                                ></path>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="4" className="text-center">
                                                No service types found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </AdminLayout>

            {/* ✅ Bootstrap Modal */}
            <div
                className="modal fade"
                id="modeldata"
                tabIndex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                {isEditMode ? "Update Service Type" : "Add Service Type"}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={onSave}>
                                <div className="mb-3">
                                    <label className="form-label">Service Name</label>
                                    <input
                                        type="text"
                                        name="serviceName"
                                        value={formData.serviceName}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Enter Service Name"
                                        required
                                    />
                                </div>

                                {/* <div className="mb-3">
                                    <label className="form-label">Description</label>
                                    <textarea
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                        className="form-control"
                                        placeholder="Enter Description"
                                        required
                                    ></textarea>
                                </div> */}

                                <div className="form-check mb-3">
                                    <input
                                        type="checkbox"
                                        name="isActive"
                                        className="form-check-input"
                                        checked={formData.isActive}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label">Active</label>
                                </div>

                                <div className="form-check mb-3">
                                    <input
                                        type="checkbox"
                                        name="isContact"
                                        className="form-check-input"
                                        checked={formData.isContact}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label">Contact Services</label>
                                </div>

                                <div className="form-check mb-3">
                                    <input
                                        type="checkbox"
                                        name="isQuote"
                                        className="form-check-input"
                                        checked={formData.isQuote}
                                        onChange={handleChange}
                                    />
                                    <label className="form-check-label">Quote Services</label>
                                </div>

                                <div className="modal-footer">
                                    <button type="submit" className="all_sumbit_button">
                                        {isEditMode ? "Update" : "Submit"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Services;
